export const formatLocaleCMS = (locale: string): string => {

    return locale.replace('-', '_')

}